module.exports = __webpack_public_path__ + "img/lamp_city.f23a0ea6.png";